<script setup>
import {ref} from "vue";
import trackersReportsService from "@/services/trackers-reports.service";
import ArrayCell from "@/components/trackers/comparisonReport/ArrayCell.vue";
import fileHelper from "@/helpers/file";

const showModal = ref(false);
const startups = ref({});
const features = ref({});
const id = ref(null);
const name = ref('');

async function getReportData() {
    const {data} = await trackersReportsService.getComparisonReportData(id.value);

    if (data) {
        [startups.value, features.value] = data;

        if (Object.keys(startups.value).length) {
            showModal.value = true;
        }
    }
}

async function download() {
    const {data} = await trackersReportsService.downloadReport(id.value);
    let currentDate = new Date();

    fileHelper.download(
        data,
        `${name.value}-${currentDate.toLocaleDateString()}.${data.type === 'application/pdf' ? 'pdf' : 'csv'}`
    );}

function open(reportId, trackerName) {
    id.value = reportId;
    name.value = trackerName;
    getReportData();
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Feature Comparison" modal-class="modal-w-xxxxl" hide-footer>
        <template #modal-header="{ close }">
            <a class="link link-export mr-4 ml-auto" @click="download">Export</a>

            <button @click="close()" type="button" aria-label="Close" class="close"></button>
        </template>

        <div class="table-comparison">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th v-for="(startupName, startupId) in startups" :key="startupId">{{startupName}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(featureData, featureName) in features" :key="featureName">
                        <td>{{featureName}}</td>
                        <td v-for="(_, startupId) in startups" :key="startupId">
                            <ArrayCell
                                v-if="Array.isArray(featureData[startupId])"
                                :items="featureData[startupId]"
                            />

                            <template v-else-if="typeof featureData[startupId] === 'number'">
                                {{featureData[startupId].toLocaleString()}}
                            </template>

                            <template v-else>
                                {{featureData[startupId]}}
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<style scoped>
</style>
